import React              from 'react';
import { useTranslation } from 'react-i18next';
import TextField          from '@material-ui/core/TextField';
import PropTypes          from 'prop-types';

const OSPublicSelector = ({ value, setValue, disabled = false, required = false, ...rest }) => {
	const { t } = useTranslation();

	return (
		<TextField
			label={t('custom_os_public_label')}
			helperText={t('custom_os_public_helperText')}
			value={value}
			onChange={e => setValue(e.target.value)}
			select
			fullWidth
			InputLabelProps={{ shrink: !!value }}
			disabled={disabled}
			required={required}
			variant='outlined'
			SelectProps={{
				native: true
			}}
			{...rest}
		>
			<option/>
			<option value='Y'>{t('custom_os_public_y')}</option>
			<option value='N'>{t('custom_os_public_n')}</option>
		</TextField>
	);
};

export default OSPublicSelector;

OSPublicSelector.propTypes = {
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	setValue: PropTypes.func.isRequired,
	value: PropTypes.string
};
